
    const  imgUrl ="https://apis.rentblaze.com/public/uploads"
    export default imgUrl